<template>
  <div style="width: 100%;">
    <l-map :style="'height: ' + height + ';'" :zoom="parseInt(zoom)" :center="center" @click="markerSet" v-if="marker" style="border-radius: 3px; border: 1px solid rgba(0, 0, 0, 0.12);">
      <l-tile-layer :url="url"></l-tile-layer>
      <l-marker :latLng="marker" :draggable="draggable" @dragend="markerDragend"></l-marker>
    </l-map>
    <v-btn @click="satelliteMode = !satelliteMode" style="float: right;" class="bw-3" v-if="marker">{{ this.satelliteMode ? 'Standard' : 'Satellite' }}</v-btn>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Maps',
  props: {
    value: Object,
    height: String,
    zoom: {
      type: String,
      default: '15'
    }
  },
  data: function () {
    return {
      urlStandard: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
      urlSatellite: 'https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiamVzcGVyd3VydHoiLCJhIjoiY2tmajgxZmx1MWZwbzJ5bzNzeWVuZTJwZyJ9.eG7TWYTjWNP-w6xav-bA6w',
      urlSatellite2: 'https://api.maptiler.com/tiles/satellite/{z}/{x}/{y}.jpg?key=4x57q5R2MThYFkqYyNFx',
      satelliteMode: false,
      draggable: true,
      center: null
    }
  },
  created: function () {
  },
  methods: {
    markerSet (event) {
      this.updatePosition(event.latlng)
    },
    markerDragend (event) {
      this.updatePosition(event.target._latlng)
    },
    updatePosition (latlng) {
      this.value.latitude = latlng.lat
      this.value.longitude = latlng.lng
      this.$emit('input', this.value)
    },
    initCenter (latlng) {
      // if (!this.center) {
      this.center = latlng
      // }
    },
    clearCenter () {
      this.center = null
    },
    addressToGeo (address) {
      // console.log('Lookup geo code for ' + address + ' using axios: ' + axios)
      let q = this.geoQuery(address)
      if (q !== '') {
        // console.log('Lookup geo for: ' + q)
        axios.get('https://nominatim.openstreetmap.org/search' + q + '?format=json').then(response => {
          // console.log('Response data: ' + response.data)
          if (response.data && Array.isArray(response.data) && response.data.length > 0) {
            let geo = response.data[0]
            // console.log('Geo: ' + JSON.stringify(geo))
            this.updatePosition({lat: geo.lat, lng: geo.lon})
          } else {
            q = this.geoQuery(address, true)
            if (q !== '') {
              axios.get('https://nominatim.openstreetmap.org/search' + this.geoQuery(address, true) + '?format=json').then(response => {
                // console.log('Response data without city: ' + response.data)
                if (response.data && Array.isArray(response.data) && response.data.length > 0) {
                  let geo = response.data[0]
                  // console.log('Geo: ' + JSON.stringify(geo))
                  this.updatePosition({lat: geo.lat, lng: geo.lon})
                }
              })
            }
          }
        })
      }
    },
    geoQuery (address, omitCity) {
      let q = ''
      if (address.country && address.country !== '') {
        q += '/' + address.country
      }
      if (address.zipCode && address.zipCode !== '') {
        q += '/' + address.zipCode
      }
      if (!omitCity && address.city && address.city !== '') {
        q += '/' + address.city
      }
      if (address.street && address.street !== '') {
        q += '/' + address.street
      }
      if (address.houseNo && address.houseNo !== '') {
        q += '/' + address.houseNo
      }
      return q
    }
  },
  computed: {
    latitude: function () {
      return this.value.latitude
    },
    longitude: function () {
      return this.value.longitude
    },
    marker: function () {
      if (this.latitude && this.longitude) {
        let latlng = [this.latitude, this.longitude]
        this.initCenter(latlng)
        return latlng
      }
      this.clearCenter()
      return null
    },
    url: function () {
      return this.satelliteMode ? this.urlSatellite : this.urlStandard
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Maps.vue